var _style, _path, _path2, _circle, _path3, _path4, _path5, _path6, _path7;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPolly(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    viewBox: "0 0 259.1 250",
    style: {
      enableBackground: "new 0 0 259.1 250"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, ".st1{fill:#e13f3e}.st9{fill:#1e693a}.st11{fill:#8a2534}")), /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M201.7 59.5s16-6.4 20.8 5.3c-7-3.6-20.8-.5-20.8-.5v-4.8z",
    style: {
      fill: "#e85c37"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M179.3 20.4s-45.6-11.5-43.7 23.7c1.6 24.1 14.8 31.1 26.9 29.7-20.3-14.1-18-33.2-10.8-41s16.1-9.9 27.6-12.4z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M132.1 42.5c1.5-3.4-1.9 32.5 15.4 33.4 17.3.9 26.3 12 25.6 15.7-.7 3.7-7.4 3.4-13.1 2.8 4.2-5.3-1.9-11.3-10.8-11.3s-29.3-12.3-17.1-40.6z"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 174.2,
    cy: 56,
    r: 13.7,
    style: {
      fill: "#61bb46"
    }
  }), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 174.2,
    cy: 60,
    r: 7.2
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 177.2,
    cy: 58.9,
    r: 2.4,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m187.2 74.9 4.6 3.1.8 3.7s-2.5 12.6-11.2 17.6c-3.6-.7-1.8-2.5-1.8-2.5s9.1-8.5 7.6-21.9z",
    style: {
      fill: "#a02c36"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.3 18.3s20.5-5.3 32.2-14.1c11.7-8.8 29.3-3.2 37.1 12.4s12 33.9 0 42.8c-12-15.6-46.7-9.2-47.7 0s9.5 19.4 19.4 17.3c2.8 9.5-22.3 21.2-36.1-1.8 21.6-14.1 15.2-43.8-4.9-56.6z",
    style: {
      fill: "#f5bb29"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.5 24.1s36.1 89.3 125.4 71.6c4 48-38.5 96.3-92.6 96.3S12.2 159.6 0 114.5c30.8 27.6 76.9 41.4 76.9 41.4l41.9-14.3-39.8-51-20.9-44.3 2.4-22.2z",
    style: {
      fill: "#802233"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.5 24.1s-18.2 44.1 25.6 95.7c21.6-7.8 17.7-12.6 17.7-12.6S58.9 81.6 60.5 24.1z",
    style: {
      fill: "#3faaed"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.8 44.1s50.8 88.9 152 62.7C148 155.9 88 141.3 86.7 140.7S52 119.8 51.2 119.8c-.8 0-23.6-34.5-23.6-34.5l-6.9-31 2.1-10.2z",
    style: {
      fill: "#629443"
    }
  }), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M22.8 44.1s-25.2 84.2 73.5 109.6c41.4-.8 46.9-24.4 46.9-24.4S35.9 161.8 22.8 44.1z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M0 114.5s88.6 65.9 174.8-7.7C166.7 165.1 55.3 215.6 0 114.5z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M62 199.9H37v38.2h12.2v-14.5H62c1.7 0 3.1-1.4 3.1-3.1V203c0-1.7-1.4-3.1-3.1-3.1zm-9.3 14c0 .7-.5 1.2-1.2 1.2h-2.3v-5.5h2.3c.7 0 1.2.5 1.2 1.2v3.1z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M91.6 199.9h-21c-1.9 0-3.4 1.5-3.4 3.4v31.5c0 1.9 1.5 3.4 3.4 3.4h21c1.9 0 3.4-1.5 3.4-3.4v-31.5c-.1-1.9-1.6-3.4-3.4-3.4zm-9.1 26.9c0 .8-.7 1.5-1.5 1.5h-.2c-.8 0-1.5-.7-1.5-1.5v-15.7c0-.8.7-1.5 1.5-1.5h.2c.8 0 1.5.7 1.5 1.5v15.7z",
    style: {
      fill: "#3586d1"
    }
  }), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "m97.6 195.6 12.5-2v46.9h23.8l2.1 9.5H99.7z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "m113.1 193.6 12.9-4.1v38.8h7.9v9.8h-20.8z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M135.9 199.9h11.9v26.6c0 1 .8 1.8 1.8 1.8s1.8-.8 1.8-1.8v-26.6h12.3V247c0 1.7-1.3 3-3 3H136v-9.6h14.1c.6 0 1.1-.5 1.1-1.1 0-.6-.5-1.1-1.1-1.1h-11.4c-1.5 0-2.7-1.2-2.7-2.7v-35.6z",
    style: {
      fill: "#eb9047"
    }
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPolly);
export default __webpack_public_path__ + "static/media/polly.2c09196b9a2fae0f2c57187ff08df6c4.svg";
export { ForwardRef as ReactComponent };